import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import React, { useEffect, useState } from "react";
// Icons
import DoneIcon from "@material-ui/icons/DoneAllTwoTone";
import EditIcon from "@material-ui/icons/EditOutlined";
import RevertIcon from "@material-ui/icons/NotInterestedOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DeleteIcon from "@mui/icons-material/Delete";
import { Icon } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import moment from "jalali-moment";
import { toast } from "react-toastify";
import {
  addReservationNoteBook,
  addReservedSubTimes,
  updateReservationNoteBook,
} from "../../api/routes";
import getMinutes from "../../components/getMinutes";
import IOSSwitch from "../../components/IOSSwitch";
import Loading from "../../components/Loading";
import MDInput from "../../components/MDInput";
import MDTypography from "../../components/MDTypography";
import useModal from "../../hooks/useModal";
import ReservationNoteBookHistoryModal from "./ReservationNoteBookHistoryModal";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
    maxWidth: "100%",
  },
  selectTableCell: {
    width: 60,
  },
  tableCell: {
    width: 130,
    height: 40,
    borderLeft: "1px solid rgba(0, 0, 0, 0.05)",
  },
  input: {
    width: 130,
    height: 40,
  },
}));

const createData = (time, id, requestGroupId,endReservationTime, reservationDate, fullNameGroup, timeSpanId, reservationDayId, subRequestGroupId) => ({
  id,
  time,
  requestGroupId,
  reservationDate,
  endReservationTime,
  fullNameGroup,
  timeSpanId,
  reservationDayId,
  subRequestGroupId,
  patientFullName: "",
  patientPhoneNumber: "",
  description: "",
  noteBookId: "",
  isEditMode: false,
});

const CustomTableCell = ({ row, name, isEditable = true, onChange, onToggleEditMode }) => {
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell align="center" onDoubleClick={() => isEditMode ? undefined : onToggleEditMode(row.id)}
      className={classes.tableCell}>
      {(isEditMode && isEditable) ? (
        <MDInput
          value={row[name]}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
        <MDTypography style={{ fontSize: 14 }}>
          {row[name]}
        </MDTypography>
      )}
    </TableCell>
  );
};

export default function NoteBookTable({ data, setReservationNoteBook, selectedDate, reservationNoteBook, tableHeight = "75vh" }) {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [copiedContent, setCopiedContent] = useState();
  const [modals, updateModal, closeModal] = useModal({ noteBookHistory: { state: false } });

  useEffect(() => {
    const updatedRows = data.flatMap(item => {
      const divideHours = Math.floor(getMinutes(item.startTime, item.endTime) / item.patientNumber);
      return Array.from({ length: item.patientNumber }, (_, i) => {
        const newTime = moment(item.startTime, "HH:mm").add(divideHours * i, "minutes").format("HH:mm");
        return createData(newTime, Math.random(), item.requestGroupId,item.endReservationTime, item.reservationDate, item.fullNameGroup, item.timeSpanId, item.reservationDayId, item.subRequestGroupId);
      });
    });

    setRows(updatedRows);
  }, [data, selectedDate]);
  const isMatchReservationWithNoteBook = (nb, row) => nb.requestGroupId === row.requestGroupId && nb.subRequestGroupId === row.subRequestGroupId && nb.reservationDayId === row.reservationDayId && nb.subTime === row.time;

  useEffect(() => {
    if (reservationNoteBook.length > 0 && data.length > 0) {
      setRows(prevRows => {
        return prevRows.map(row => {
          const reservedItem = reservationNoteBook.find(nb => isMatchReservationWithNoteBook(nb, row));
          if (reservedItem) {
            return {
              ...row,
              patientFullName: reservedItem.fullname,
              patientPhoneNumber: reservedItem.phoneNumber,
              description: reservedItem.description,
              noteBookId: reservedItem.id,
              isChecked: reservedItem.isChecked,
              isAdmission: reservedItem.isAdmission,
            };
          }
          return row;
        });
      });
    }
  }, [reservationNoteBook, data, selectedDate]);

  const [previous, setPrevious] = React.useState({});
  const classes = useStyles();

  const onToggleEditMode = id => {
    setRows(state => {
      return rows.map(row => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const isUpdateStatus = (rowId) => {
    let isUpdate = false;
    if (reservationNoteBook.length > 0) {
      const noteBookIndex = reservationNoteBook.findIndex(nb => isMatchReservationWithNoteBook(nb, rows.find(row => row.id === rowId)));
      if (noteBookIndex !== -1)
        isUpdate = true;
    }
    return isUpdate;
  };
  const onSubmitClick = (id) => {
    if (!isUpdateStatus(id)) {
      const submittedRow = rows.find(row => row.id === id);
      const subTimeData = {
        reservationDayId: submittedRow.reservationDayId,
        requestGroupId: submittedRow.requestGroupId,
        subRequestGroupId: submittedRow.subRequestGroupId,
        subTime: submittedRow.time,
        reservationDate: submittedRow.reservationDate,
        endReservationTime:submittedRow.endReservationTime,
        isReservationNoteBook: true,
      };
      setLoading(true);
      addReservedSubTimes(subTimeData, (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          const notebookData = {
            fullname: submittedRow.patientFullName,
            phoneNumber: submittedRow.patientPhoneNumber,
            description: submittedRow.description,
            requestGroupId: submittedRow.requestGroupId,
            subRequestGroupId: submittedRow.subRequestGroupId,
            reservationDayId: submittedRow.reservationDayId,
            timeSpanId: submittedRow.timeSpanId,
            reservedSubTimesId: data[0].reservedSubTimesId,
          };
          addReservationNoteBook(notebookData, (isOk, data) => {
            if (!isOk) {
              setLoading(false);
              return toast.error(data.message);
            } else {
              setLoading(false);
              toast.success("نوبت اضافه شد!");
              onToggleEditMode(id);
            }
          });
        }
      });

    } else {
      setLoading(true);
      const submittedRow = rows.find(row => row.id === id);
      const notebookData = {
        fullname: submittedRow.patientFullName,
        phoneNumber: submittedRow.patientPhoneNumber,
        description: submittedRow.description,
      };
      updateReservationNoteBook(submittedRow.noteBookId, notebookData, (isOk, data) => {
        setLoading(false);
        if (!isOk) {
          return toast.error(data.message);
        } else {
          toast.success("اطلاعات آپدیت شد!");
          onToggleEditMode(id);
        }
      });
    }
  };
  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious(state => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onRevert = id => {
    const newRows = rows.map(row => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious(state => {
      delete state[id];
      return state;
    });
    onToggleEditMode(id);
  };
  const pasteContent = (item) => {
    if (copiedContent) {
      setRows(state => {
        return state.map(row => {
          if (row.id === item.id) {
            return {
              ...row,
              patientFullName: copiedContent?.patientFullName,
              patientPhoneNumber: copiedContent?.patientPhoneNumber,
              description: copiedContent?.description,
              isEditMode: !row.isEditMode,
            };
          }
          return row;
        });
      });
    } else return toast.error("سطری کپی نشده است!");
  };

  const onDeleteClick = (item) => {
    if (item.noteBookId) {
      let answer = window.confirm("آیا از حذف اطمینان دارید؟");
      if (answer) {
        const notebookData = {
          fullname: "",
          phoneNumber: "",
          description: "",
          isChecked: 0,
          isAdmission: 0
        };
        setLoading(true);
        updateReservationNoteBook(item.noteBookId, notebookData, (isOk, data) => {
          setLoading(false);
          if (!isOk) {
            return toast.error(data.message);
          } else {
            toast.success("اطلاعات آپدیت شد!");
            setRows(state => {
              return state.map(row => {
                if (row.id === item.id) {
                  return {
                    ...row,
                    patientFullName: "",
                    patientPhoneNumber: "",
                    description: "",
                    isChecked: 0,
                    isAdmission: 0
                  };
                }
                return row;
              });
            });
          }
        });
      }
    } else return toast.error("امکان حذف وجود ندارد!");
  };
  const isCheckHandle = (event, noteBookId) => {
    if (noteBookId) {
      setLoading(true);
      setReservationNoteBook((prev) => prev.map(notebook => {
        if (notebook.id === noteBookId)
          return { ...notebook, isChecked: event.target.checked };

        else return notebook;
      }));
      const data = {
        isChecked: +event.target.checked,
      };
      updateReservationNoteBook(noteBookId, data, (isOk, data) => {
        setLoading(false);
        if (!isOk) {
          return toast.error(data.message);
        } else {
          toast.success("وضعیت تغییر کرد!");
        }
      });
    }
  };
  const isAdmissionHandle = (event, noteBookId) => {
    if (noteBookId) {
      setLoading(true);
      setReservationNoteBook((prev) => prev.map(notebook => {
        if (notebook.id === noteBookId)
          return { ...notebook, isAdmission: event.target.checked };

        else return notebook;
      }));
      const data = {
        isAdmission: +event.target.checked,
      };
      updateReservationNoteBook(noteBookId, data, (isOk, data) => {
        setLoading(false);
        if (!isOk) {
          return toast.error(data.message);
        } else {
          toast.success("وضعیت تغییر کرد!");
        }
      });
    }
  };

  return (
    <Paper className={classes.root}>
      <Loading loading={loading} />
      <TableContainer style={{ maxHeight: tableHeight }}>
        <Table stickyHeader className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.05)" }}><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>ردیف</MDTypography></TableCell>
              <TableCell align="center" style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.05)" }}><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>ساعت</MDTypography></TableCell>
              <TableCell align="center" style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.05)" }}><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>نام
                بیمار</MDTypography></TableCell>
              <TableCell align="center" style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.05)" }}><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>درخواست</MDTypography></TableCell>
              <TableCell align="center" style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.05)" }}><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>شماره تماس</MDTypography></TableCell>
              <TableCell align="center" style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.05)" }}><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>توضیحات</MDTypography></TableCell>
              <TableCell align="center" style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.05)" }}><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>تایید حضور</MDTypography></TableCell>
              <TableCell align="center" ><MDTypography
                style={{ fontSize: 16, fontWeight: 800 }}>تایید پرونده</MDTypography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id} className={copiedContent?.id === row.id ? "blink" : ""}
                style={{ backgroundColor: copiedContent?.id === row.id ? "rgba(73, 163, 241,0.1)" : "" }}>
                <TableCell align="center" onDoubleClick={() => onToggleEditMode(row.id)}
                  className={classes.tableCell}>
                  <div style={{ position: "relative" }}>
                    <section style={{ display: "flex", top: "-10px", position: "absolute", flexDirection: "column" }}>
                      {copiedContent?.id === row.id ?
                        <IconButton size={"small"} onClick={() => setCopiedContent(undefined)}>
                          <ClearIcon size={14} color={"error"} />
                        </IconButton>
                        : <IconButton size={"small"} onClick={() => setCopiedContent(row)}>
                          <ContentCopyIcon size={14} />
                        </IconButton>}
                      <IconButton size={"small"} onClick={() => pasteContent(row)}>
                        <ContentPasteIcon size={14} />
                      </IconButton>
                    </section>
                    <MDTypography style={{ fontSize: 14 }}>
                      {index + 1}
                    </MDTypography>
                  </div>
                </TableCell>
                <CustomTableCell {...{ row, isEditable: false, name: "time", onChange, onToggleEditMode }} />
                <CustomTableCell {...{ row, name: "patientFullName", onChange, onToggleEditMode }} />
                <CustomTableCell {...{ row, isEditable: false, name: "fullNameGroup", onChange, onToggleEditMode }} />
                <CustomTableCell {...{ row, name: "patientPhoneNumber", onChange, onToggleEditMode }} />
                <CustomTableCell {...{ row, name: "description", onChange, onToggleEditMode }} />
                <TableCell align={"center"} className={classes.selectTableCell}>
                  {row.noteBookId &&
                    <IOSSwitch checked={row.isChecked}
                      onChange={(event) => isCheckHandle(event, row.noteBookId)} />}
                </TableCell>

                <TableCell align="center" className={classes.selectTableCell}>
                  {row.isEditMode ? (
                    <>
                      <IconButton
                        aria-label="done"
                        onClick={() => onSubmitClick(row.id)}
                      >
                        <DoneIcon />
                      </IconButton>
                      <IconButton
                        aria-label="revert"
                        onClick={() => onRevert(row.id)}
                      >
                        <RevertIcon />
                      </IconButton>
                    </>
                  ) : (
                    <div>
                      <section style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                        <IconButton
                          aria-label="edit"
                          size={"small"}
                          onClick={() => onToggleEditMode(row.id)}
                        >
                          <EditIcon />
                        </IconButton>
                        {row.noteBookId && <IconButton
                          aria-label="delete"
                          size={"small"}
                          onClick={() => onDeleteClick(row)}
                        >
                          <DeleteIcon color={"error"} />
                        </IconButton>}
                        {row.noteBookId && <IconButton size={"small"} onClick={() => updateModal("noteBookHistory", {
                          state: true,
                          item: reservationNoteBook.find(item => item.id === row.noteBookId),
                        })}>
                          <Icon color={"info"}
                          >history</Icon>
                        </IconButton>}
                      </section>
                      {row.noteBookId &&
                        <IOSSwitch checked={row.isAdmission}
                          onChange={(event) => isAdmissionHandle(event, row.noteBookId)} />}
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {modals.noteBookHistory.state &&
        <ReservationNoteBookHistoryModal modal={modals.noteBookHistory}
          handleClose={() => closeModal("noteBookHistory")} />}
    </Paper>
  );
}
